import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from '../Results.pcss';
const Header = ({ isInProgress, renderPatientHeader })=>/*#__PURE__*/ _jsx("div", {
        className: "widget widget--noHeader",
        "data-testid": "patient-header",
        children: /*#__PURE__*/ _jsx("div", {
            className: "widget__content",
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.headerWrapper,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.header,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: cn('row align-items-center', styles.patientHeader),
                        children: renderPatientHeader(isInProgress)
                    })
                })
            })
        })
    });
export default Header; /*
    TODO: Moved from old component just in case it turns out to be needed after all. Check if this method is obsolete.

    renderHeaderToggles() {
      if (!this.props.featureToggles.includes(App.constants.FEATURE_TOGGLES.featureCgm)) {
        return null;
      }
      const { setDashboardLayout, dashboardLayout } = this.props;
      const { isInProgress } = this.state;
      return (
        <div className={styles.topBar}>
          <div className={cn(styles.topBar__left, { fadingLoader: isInProgress })}>
            <Button
              styleModifier="transparent"
              className={
                cn(
                  styles.topBar__button,
                  {
                    [styles['topBar__button--active']]: isEqual(dashboardLayout, constants.DASHBOARD_LAYOUTS.bgm),
                  },
                )
              }
              isDisabled={isInProgress}
              onClick={() => setDashboardLayout(constants.DASHBOARD_LAYOUTS.bgm)}
            >
              <Dashboard />
              <FormattedMessage {...messages.buttons.standard} />
            </Button>
            <Button
              styleModifier="transparent"
              className={
                cn(
                  styles.topBar__button,
                  {
                    [styles['topBar__button--active']]: isEqual(dashboardLayout, constants.DASHBOARD_LAYOUTS.agp),
                  },
                )
              }
              isDisabled={isInProgress}
              onClick={() => setDashboardLayout(constants.DASHBOARD_LAYOUTS.agp)}
            >
              <Dashboard />
              <FormattedMessage {...messages.buttons.agpcgm} />
            </Button>
          </div>
        </div>
      );
    }
 */ 
